import React from "react";

// Catalogo de icones disponiveis para abas da sidebar.
// O "value" e o que vai persistido em links.json no campo "icon" da aba.
// Mantemos o vocabulario alinhado com a paleta semantica dos cards.
export const TAB_ICON_OPTIONS = [
  { value: "home",      label: "Casa",          hint: "Pagina inicial" },
  { value: "folder",    label: "Pasta",         hint: "Manuais, normas, procedimentos" },
  { value: "chart",     label: "Gráfico",       hint: "Métricas, progresso, análise" },
  { value: "clipboard", label: "Prancheta",     hint: "Formulários, afazeres" },
  { value: "school",    label: "Formatura",     hint: "Cursos e treinamentos" },
  { value: "lock",      label: "Cadeado",       hint: "Privacidade e segurança" },
  { value: "people",    label: "Pessoas",       hint: "Assuntos gerais" },
];

// Paths SVG dos icones (viewBox 0 0 24 24).
const TAB_ICON_PATHS = {
  home:      "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
  folder:    "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z",
  chart:     "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z",
  clipboard: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
  school:    "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z",
  lock:      "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z",
  people:    "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
};

// Compatibilidade: quando uma aba nao tem campo "icon", caimos no mapeamento
// historico por ID (criados antes da feature). Se o ID nao bate, usa "folder".
const LEGACY_ID_TO_ICON = {
  home:         "home",
  documentacao: "folder",
  sistemas:     "clipboard",
  rh:           "people",
  dados:        "chart",
  dev:          "folder",
  lideranca:    "lock",
  treinamentos: "school",
};

export function resolveTabIcon(tab) {
  if (!tab) return "folder";
  if (tab.icon && TAB_ICON_PATHS[tab.icon]) return tab.icon;
  if (tab.id && LEGACY_ID_TO_ICON[tab.id]) return LEGACY_ID_TO_ICON[tab.id];
  return "folder";
}

export default function TabIcon({ name, className }) {
  const path = TAB_ICON_PATHS[name] || TAB_ICON_PATHS.folder;
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d={path} />
    </svg>
  );
}
